import * as React from 'react';
import { illustrationColors } from '../colors';
import { getColorValue } from '../utilities/color';

function Search(props) {
  const orange = getColorValue('illustrationOrange');
  const blue = getColorValue('illustrationAccent');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path
        d="m186.119 90.564c-2.07-3.97-4.61-7.92-7.64-11.84-3.07-3.97-6.31-7.47-9.67-10.51-20.01-18.08-44.6-19.74-67.63-7.25-3.9299 2.13-7.8099 4.67-11.6199 7.61-3.97 3.07-7.54 6.33-10.7 9.74-17.83 19.24-22.4 43.41-10.04 67.21 2.09 4.02 4.66 8.03 7.73 12.01 3.03 3.92 6.22 7.37 9.54 10.37 19.8799 17.95 44.4499 19.62 67.5899 7.18 4.1-2.2 8.15-4.83 12.12-7.9 3.81-2.94 7.24-6.07 10.29-9.33 17.91-19.17 22.48-43.43 10.01-67.29z"
        fill={orange}
      />
      <path
        clipRule="evenodd"
        d="m81.4986 172.994c12.51 11.29 27.0504 17.01 42.2504 17.01v-.01c10.89 0 22.13-2.94 33.18-8.88 3.235-1.742 6.439-3.73 9.562-5.932.367 1.127 1.03 2.333 2.028 3.622l4.24 5.48 11.75-9.09-4.24-5.48c-1.049-1.461-2.121-2.487-3.206-3.132 1.409-1.324 2.76-2.679 4.046-4.058 20.52-21.96 24.56-49.35 11.08-75.1405-2.28-4.36-5.07-8.69-8.3-12.86-3.28-4.23-6.81-8.06-10.5-11.4-21.59-19.51-49.11-22.5-75.4904-8.19-4.27 2.32-8.49 5.09-12.54 8.22-4.2 3.25-8.08 6.79-11.53 10.51-20.39 22.01-24.43 49.3605-11.09 75.0305 2.29 4.42 5.12 8.81 8.39 13.04 3.23 4.17 6.72 7.96 10.37 11.26zm22.9404-106.0105c8.96-4.87 17.92-7.28 26.57-7.28h.02c11.88 0 23.2 4.56 33.2 13.59 3.09 2.79 6.06 6.03 8.84 9.62 2.73 3.53 5.09 7.18 6.99 10.82 10.77 20.6205 7.6 41.7305-8.95 59.4405-2.82 3.01-6 5.9-9.48 8.59-3.61 2.8-7.37 5.25-11.17 7.29-21.38 11.48-42.6 9.27-59.7604-6.23-3.06-2.76-5.99-5.95-8.72-9.48-2.78-3.58-5.16-7.28-7.08-10.97-10.67-20.54-7.48-41.63 8.98-59.4005 2.93-3.17 6.25-6.19 9.86-8.98 3.48-2.68 7.0804-5.04 10.7004-7.01z"
        fill={blue}
        fillRule="evenodd"
      />
      <path
        d="m187.466 172.926-17.642 13.64 33.152 42.879 17.642-13.64z"
        fill={blue}
      />
      <path
        d="m184.63 175.119-11.97 9.254 11.243 14.541 11.969-9.255z"
        fill={illustrationColors.staticDarkBlue}
      />
    </svg>
  );
}

export default Search;
